/** 5 statuses per US-001 / US-028 / US-062 — matches the reference UI. */
export const SOLVE_STATUSES = [
    "Draft",
    "Active",
    "Verified",
    "Closed",
    "Archived",
];
/**
 * The three artifacts a SOLVE must hold before it may be completed (PB-5272).
 *
 * Ordered as the methodology walks them — Specify, Look, Verify — so the UI
 * checklist and a refusal's `details.missing` read in the order the user
 * authored them.
 *
 * **Declared here so the server and its clients cannot drift.** They agree
 * today; if the server added a fourth requirement first, a client indexing
 * {@link SOLVE_COMPLETION_REQUIREMENT_LABELS} with the new value would read
 * `undefined` and throw on the next string call. One declaration makes that a
 * compile error in both directions.
 */
export const SOLVE_COMPLETION_REQUIREMENTS = [
    "problem_statement",
    "root_cause",
    "completed_countermeasure",
];
/**
 * What each requirement is called on screen.
 *
 * One map for the completion popover's checklist AND the advance-phase
 * warning, so two surfaces cannot describe the same requirement differently.
 */
export const SOLVE_COMPLETION_REQUIREMENT_LABELS = {
    problem_statement: "A problem statement",
    root_cause: "A documented root cause",
    completed_countermeasure: "At least one completed countermeasure",
};
/** S-O-L-V-E phases per methodology.md (line 103). */
export const SOLVE_PHASES = [
    "Specify",
    "Oppress",
    "Look",
    "Verify",
    "Ensure",
];
/**
 * How Player AI talks in this SOLVE's shared conversation. A property of the
 * SOLVE, not of a user or a conversation: a shared transcript needs one stable
 * voice, so tone cannot depend on who triggered a given Run.
 */
export const SOLVE_RESPONSE_STYLES = ["direct", "empathetic"];
/** User-facing labels. `Direct` names the alternative without implying empathy is exceptional. */
export const SOLVE_RESPONSE_STYLE_LABELS = {
    direct: "Direct",
    empathetic: "Empathetic",
};
/**
 * New and existing SOLVEs are Empathetic. The SOLVE Expert Pack already casts
 * Player AI as an empathetic colleague, so this preserves current behaviour and
 * makes Direct an explicit opt-in.
 */
export const SOLVE_DEFAULT_RESPONSE_STYLE = "empathetic";
/** Shared SOLVE canvas bounds used by product placement and frontend layout. */
export const SOLVE_CANVAS_BOUNDS = {
    width: 4_080,
    height: 2_000,
};
/** Short phase letter for the PhaseStrip UI. */
export const PHASE_LETTER = {
    Specify: "S",
    Oppress: "O",
    Look: "L",
    Verify: "V",
    Ensure: "E",
};
export function phaseIndex(phase) {
    return SOLVE_PHASES.indexOf(phase);
}
//# sourceMappingURL=solve.js.map